import React, { useState } from "react";
import kwilLogo from "../assets/kwil-logo.svg";
import { ReactComponent as Metamask} from "../assets/metamask.svg";
import { Button, Snackbar, Alert } from "@mui/material";
import "../styling/SignIn.css";
import { ethers } from "ethers";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import { resetLoadedMoat } from "../redux/slices/loadedMoat";
import { resetPrivateKey } from "../redux/slices/privateKeySlice";
import { resetSecret } from "../redux/slices/secretSlice";
import { resetPool } from "../redux/slices/fundingPools";
import { resetToggleControl } from "../redux/slices/toggleControlSlices";
import MailchimpFormContainer from "../components/v2SignUp-components/MailchimpFormContainer";


export default function SignIn() {
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("")
    const [openForm, setOpenForm] = useState(false)
    const navigate = useNavigate();
    const dispatch = useDispatch();

    function resetState() {
      dispatch(resetPrivateKey())
      dispatch(resetSecret())
      dispatch(resetLoadedMoat())
      dispatch(resetPool())
      dispatch(resetToggleControl())
      sessionStorage.removeItem('persist:root')
      localStorage.setItem('SELECT', "")
    }
    
    const signIn = async () => {
      sessionStorage.clear();
        if (window.ethereum) {
          try {
            await window.ethereum.request({ method: "eth_requestAccounts" });
            localStorage.setItem("wallet", "metamask")
            await window.ethereum.send("eth_requestAccounts");
            const provider = ((window.ethereum != null) ? new ethers.providers.Web3Provider(window.ethereum) : ethers.providers.getDefaultProvider());
            const signer = provider.getSigner();
            const address = await signer.getAddress();
            localStorage.setItem("address", address);
            resetState();
            navigate("/home");
          } catch (error) {
            if (error.code === 40001) {
              setError("User rejected request")
            } else {
              setError(error.message);
            }
          }
        } else {
          setError("MetaMask not detected. Please install Metamask on your browser.")
        }
    }

    function addUnderline(e) {
      e.target.style.textDecorationLine = "underline"
    }

    function removeUnderline(e) {
      e.target.style.textDecorationLine = ""
    }


    return(
    <div className="background" style={{
      width: "100vw",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background:
          "radial-gradient(circle at 67.3% 30%, background: rgba(103, 200, 255, 0.35) 50%)" +
          "radial-gradient(ellipse at 10% 80%, rgba(0,255,255,1) 0%, rgba(0,0,0,1) 30%), " +
          "linear-gradient(0deg, #141235, #141235), radial-gradient(106.87% 149.6% at -5.87% -6.88%, #0E205F 0%, rgba(14, 32, 95, 0) 100%), #040417",
        overflow: "hidden",
    }}>
        <Helmet>
          <title>Sign In | KwilDB</title>
          <meta
            name="description"
            content="KwilDB is the first decentralized SQL database, enabling complex, highly-scalable, decentralized applications."
          />
        </Helmet>
        <signbox>
          <div className="heybobbybobbybobby">
          <img src={kwilLogo} alt="kwil-logo" />
            <h3>Connect your Wallet</h3>
            <Button onClick={() => signIn()} variant="contained" sx={{
              backgroundColor: "#fff",
              height: "52px",
              borderRadius: "12px",
              boxShadow: "none",
              color: "#000",
              textTransform: "none",
              fontSize: "20px",
              width: "100%"
            }}>
              <p className="button-title">MetaMask</p>
              <Metamask style={{marginLeft: "4.5px"}}/>
            </Button>
            <Button
              sx={{
                backgroundColor: "#fff",
                height: "45px",
                borderRadius: "12px",
                boxShadow: "none",
                color: "#000",
                textTransform: "none",
                fontSize: "20px",
                top: "0",
                marginTop: "40px",
                width: "300px",
                "&:hover" : {backgroundColor: "#118EA0"},
                zIndex: "1002"
              }}
              onClick={() => setOpenForm(true)}
            >
              <p className="button-title">Sign up for Kwilv2 Access</p>
            </Button>
          </div>
        </signbox>
        <div className="box-1"></div>
        <div className="box-2"></div>
        <svg
          className="circle-1"

          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="50%" cy="50%" r="4"  fill="#ffffff"/>
        </svg>
        <svg
          className="circle-2"

          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="50%" cy="50%" r="4"  fill="#ffffff"/>
        </svg>
        <svg className="line-1"  height="509" viewBox="0 0 100% 100%" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 -368.5L942.5 -368.5L942.5 369C942.5 446.044 880.044 508.5 803 508.5L140 508.5C62.9563 508.5 0.5 446.044 0.5 369L0.5 -368.5Z" stroke="url(#paint0_linear_2_1607)"/>
            <defs>
            <linearGradient id="paint0_linear_2_1607" x1="471.5" y1="-369" x2="484.519" y2="414.508" gradientUnits="userSpaceOnUse">
            <stop stop-color="#6D7FFD"/>
            <stop offset="1" stop-color="#6D7FFD" stop-opacity="0"/>
            </linearGradient>
            </defs>
        </svg>
        <svg className="line-2"  height="509" viewBox="0 0 100% 100%" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 -368.5L942.5 -368.5L942.5 369C942.5 446.044 880.044 508.5 803 508.5L140 508.5C62.9563 508.5 0.5 446.044 0.5 369L0.5 -368.5Z" stroke="url(#paint0_linear_2_1607)"/>
            <defs>
            <linearGradient id="paint0_linear_2_1607" x1="471.5" y1="-369" x2="484.519" y2="414.508" gradientUnits="userSpaceOnUse">
            <stop stop-color="#6D7FFD"/>
            <stop offset="1" stop-color="#6D7FFD" stop-opacity="0"/>
            </linearGradient>
            </defs>
        </svg>
        <div className="circle-3-container">
          {/* <svg
            className="circle-3"
    
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="50%" cy="50%" r="287"  fill="#ffffff"/>
          </svg> */}
          <div className="circle-3"></div>
        </div>
        <div style={{ display: "flex", flexDirection:"column"}}>
          <Snackbar
          sx={{ margin: "0px auto" }}
          open={error}
          autoHideDuration={6000}
          onClose={() => setError("")}
          >
            <Alert
              variant="filled"
              onClose={() => setError("")}
              severity="error"
              sx={{ width: "100%" }}
            >
              {error}
            </Alert>
          </Snackbar>
          <Snackbar
          sx={{ margin: "0px auto" }}
          open={success}
          autoHideDuration={6000}
          onClose={() => setSuccess("")}
          >
            <Alert
              variant="filled"
              onClose={() => setSuccess("")}
              severity="success"
              sx={{ width: "100%" }}
            >
              {success}
            </Alert>
          </Snackbar>
        </div>
        <MailchimpFormContainer
          openForm={openForm}
          setOpenForm={setOpenForm}
          setError={setError}
          setSuccess={setSuccess}
        />
        <div className="SBF">
          <div className="bottom-buttons">
              <p className="boring privacy" onClick={() => navigate('/privacy')} onMouseEnter={addUnderline} onMouseLeave={removeUnderline}>Privacy Policy</p>
              <p className="boring terms"onClick={() => navigate('/terms')} onMouseEnter={addUnderline} onMouseLeave={removeUnderline}>Terms and Conditions</p>
          </div>
        </div>
      </div>
    )
}